<!-- Financial Report -->
<div class="financial-report-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-main">
        <div class="header-icon">
          <i class="fas fa-wallet"></i>
        </div>
        <div class="header-text">
          <h1 class="page-title">Wallet Transactions</h1>
          <p class="page-description">Monitor wallet funding transactions and settlement records</p>
        </div>
      </div>
      <div class="header-actions">
        <button class="btn btn-outline-secondary" (click)="getMonicreditTransactions(1)">
          <i class="fas fa-sync-alt me-1" [class.fa-spin]="isLoading"></i>Refresh
        </button>
        <button class="btn btn-primary" (click)="exportToExcel()" [disabled]="isExporting">
          <span *ngIf="!isExporting">
            <i class="fas fa-file-excel me-1"></i>Export
          </span>
          <span *ngIf="isExporting">
            <i class="fas fa-spinner fa-spin me-1"></i>Exporting...
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- KPI Summary Cards -->
  <div class="row g-3 mb-4">
    <!-- Wallet Balance Card -->
    <div class="col-xl-6 col-lg-6">
      <div style="background: linear-gradient(135deg, var(--accent), var(--accent-hover)); border-radius: var(--radius-lg); padding: 24px; box-shadow: var(--shadow-md); position: relative; overflow: hidden;">
        <div style="position: absolute; top: -20px; right: -20px; width: 100px; height: 100px; border-radius: 50%; background: rgba(255,255,255,0.08);"></div>
        <div style="position: absolute; bottom: -30px; right: 30px; width: 80px; height: 80px; border-radius: 50%; background: rgba(255,255,255,0.05);"></div>
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; position: relative; z-index: 1;">
          <div style="width: 42px; height: 42px; border-radius: var(--radius-md); background: rgba(255,255,255,0.2); display: flex; align-items: center; justify-content: center; font-size: 18px; color: #fff;">
            <i class="fas fa-wallet"></i>
          </div>
        </div>
        <div style="position: relative; z-index: 1;">
          <div style="font-size: 12px; font-weight: 500; color: rgba(255,255,255,0.8); text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 6px;">Wallet Balance</div>
          <div style="font-size: 28px; font-weight: 700; color: #fff; line-height: 1.2;">₦{{walletBalance?.formatted_balance || '0.00'}}</div>
        </div>
      </div>
    </div>

    <!-- Dynamic Summary Cards -->
    <div class="col-xl-6 col-lg-6" *ngFor="let card of summaryCards; let i = index">
      <div style="background: var(--card-bg); border: 1px solid var(--card-border); border-radius: var(--radius-lg); padding: 20px; box-shadow: var(--card-shadow);">
        <div class="d-flex align-items-start justify-content-between mb-3">
          <div style="width: 42px; height: 42px; border-radius: var(--radius-md); display: flex; align-items: center; justify-content: center; font-size: 16px;"
               [ngStyle]="{
                 'background': card.color === 'primary' ? 'var(--accent-subtle)' : card.color === 'success' ? 'var(--success-bg)' : card.color === 'warning' ? 'var(--warning-bg)' : 'var(--info-bg)',
                 'color': card.color === 'primary' ? 'var(--accent)' : card.color === 'success' ? 'var(--success-text)' : card.color === 'warning' ? 'var(--warning-text)' : 'var(--info-text)'
               }">
            <i [class]="card.icon"></i>
          </div>
        </div>
        <div *ngIf="!isLoadingSummary">
          <div style="font-size: 12px; font-weight: 500; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 6px;">{{card.title}}</div>
          <div style="font-size: 24px; font-weight: 700; color: var(--text-primary); line-height: 1.2;">
            <span *ngIf="card.title === 'Total Transactions'; else totalAmounts">
              {{card.value | number:'1.0-0'}}
            </span>
            <ng-template #totalAmounts>
              ₦{{card.value | number:'1.2-2'}}
            </ng-template>
          </div>
          <div style="margin-top: 10px; display: flex; align-items: center; gap: 6px;">
            <span class="badge badge-sm" [ngClass]="getTrendClass(i) === 'positive' ? 'badge-success' : 'badge-danger'" style="font-size: 11px;">
              <i [class]="getTrendIcon(i)" style="font-size: 9px; margin-right: 2px;"></i>{{getTrendValue(i)}}%
            </span>
            <span style="font-size: 12px; color: var(--text-tertiary);">vs last month</span>
          </div>
        </div>
        <!-- Loading Shimmer -->
        <div *ngIf="isLoadingSummary">
          <div class="loading-shimmer" style="width: 60%; height: 14px; margin-bottom: 8px; border-radius: 4px;"></div>
          <div class="loading-shimmer" style="width: 90%; height: 28px; margin-bottom: 10px; border-radius: 6px;"></div>
          <div class="loading-shimmer" style="width: 75%; height: 12px; border-radius: 4px;"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Collapsible Filters Panel -->
  <div class="filters-panel" style="margin-bottom: 20px;">
    <div style="display: flex; align-items: center; justify-content: space-between; cursor: pointer;"
         (click)="toggleFiltersCollapse()">
      <div style="display: flex; align-items: center; gap: 12px;">
        <div style="width: 32px; height: 32px; border-radius: var(--radius-sm); background: var(--accent-subtle); color: var(--accent); display: flex; align-items: center; justify-content: center; font-size: 14px;">
          <i class="fas fa-sliders-h"></i>
        </div>
        <div>
          <div style="font-size: 14px; font-weight: 600; color: var(--text-primary);">Advanced Filters</div>
          <div style="font-size: 12px; color: var(--text-tertiary);">{{isFiltersCollapsed ? 'Click to expand and refine your search' : 'Refine your search to find specific records'}}</div>
        </div>
      </div>
      <div style="display: flex; align-items: center; gap: 10px;">
        <button class="btn btn-sm" style="background: var(--danger-bg); color: var(--danger-text); border: 1px solid var(--danger-border); font-size: 12px; padding: 4px 10px;"
                (click)="clearAllFilters(); $event.stopPropagation()" *ngIf="hasActiveFilters() && !isFiltersCollapsed">
          <i class="fas fa-times me-1"></i>Clear All
        </button>
        <span *ngIf="hasActiveFilters()" class="badge badge-soft-primary badge-sm">
          {{getActiveFiltersCount()}} active
        </span>
        <i class="fas fa-chevron-down"
           style="font-size: 12px; color: var(--text-tertiary); transition: transform 0.3s ease;"
           [style.transform]="!isFiltersCollapsed ? 'rotate(180deg)' : 'rotate(0deg)'"></i>
      </div>
    </div>

    <div [@slideDown]="isFiltersCollapsed ? 'collapsed' : 'expanded'"
         [class.collapsed]="isFiltersCollapsed">
      <div style="padding-top: 16px; border-top: 1px solid var(--border-subtle); margin-top: 16px;">
        <div class="row g-3">
          <!-- Date Range Filter -->
          <div class="col-lg-4">
            <label style="font-size: 12px; font-weight: 600; color: var(--text-secondary); display: flex; align-items: center; gap: 6px; margin-bottom: 8px;">
              <i class="fas fa-calendar-alt" style="font-size: 12px;"></i>Date Range
              <div *ngIf="dateRange.from || dateRange.to" style="width: 6px; height: 6px; border-radius: 50%; background: var(--accent);"></div>
            </label>
            <div style="position: relative;">
              <input
                class="form-control"
                placeholder="Select date range"
                name="dp"
                [(ngModel)]="dateRange"
                ngbDatepicker
                #dp="ngbDatepicker"
                readonly
                (dateSelect)="onDateSelection($event)"
                [displayMonths]="2"
                [dayTemplate]="dayTemplate"
                outsideNavigation="select"
                style="padding-right: 70px;">
              <div style="position: absolute; right: 4px; top: 50%; transform: translateY(-50%); display: flex; gap: 2px;">
                <button class="btn btn-sm" type="button" (click)="dp.toggle()" style="padding: 4px 8px; background: transparent; border: none; color: var(--text-tertiary);">
                  <i class="fas fa-calendar-alt"></i>
                </button>
                <button class="btn btn-sm" type="button" (click)="clearDateFilter()"
                        *ngIf="dateRange.from || dateRange.to"
                        style="padding: 4px 8px; background: transparent; border: none; color: var(--text-tertiary);">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            <div *ngIf="dateRange.from && dateRange.to" style="margin-top: 6px; font-size: 12px; color: var(--accent); display: flex; align-items: center; gap: 4px;">
              <i class="fas fa-calendar-check" style="font-size: 10px;"></i>
              {{formatDate(dateRange.from)}} - {{formatDate(dateRange.to)}}
            </div>
          </div>

          <!-- Transaction Type Filter -->
          <div class="col-lg-4">
            <label style="font-size: 12px; font-weight: 600; color: var(--text-secondary); display: flex; align-items: center; gap: 6px; margin-bottom: 8px;">
              <i class="fas fa-exchange-alt" style="font-size: 12px;"></i>Transaction Type
              <div *ngIf="selectedPaymentMethod" style="width: 6px; height: 6px; border-radius: 50%; background: var(--accent);"></div>
            </label>
            <select class="form-select"
                    [(ngModel)]="selectedPaymentMethod"
                    (change)="onPaymentMethodChange()">
              <option value="">All Transaction Types</option>
              <option value="fund_wallet">Fund Wallet</option>
              <option value="transfer">Transfer</option>
              <option value="withdrawal">Withdrawal</option>
              <option value="settlement">Settlement</option>
            </select>
            <div *ngIf="selectedPaymentMethod" style="margin-top: 6px;">
              <span class="badge badge-soft-primary badge-sm">
                {{getPaymentMethodDisplay(selectedPaymentMethod)}}
              </span>
            </div>
          </div>

          <!-- Search Filter -->
          <div class="col-lg-4">
            <label style="font-size: 12px; font-weight: 600; color: var(--text-secondary); display: flex; align-items: center; gap: 6px; margin-bottom: 8px;">
              <i class="fas fa-search" style="font-size: 12px;"></i>Search
              <div *ngIf="searchTerm" style="width: 6px; height: 6px; border-radius: 50%; background: var(--accent);"></div>
            </label>
            <div style="position: relative;">
              <input
                type="text"
                class="form-control"
                placeholder="Reference, account name, or amount..."
                [(ngModel)]="searchTerm"
                (ngModelChange)="onSearchChange()"
                #searchInput
                style="padding-right: 36px;">
              <div style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%);">
                <i class="fas fa-search" *ngIf="!searchTerm" style="font-size: 12px; color: var(--text-tertiary);"></i>
                <button *ngIf="searchTerm" type="button"
                        (click)="clearSearch()"
                        style="background: none; border: none; padding: 0; color: var(--text-tertiary); cursor: pointer;">
                  <i class="fas fa-times" style="font-size: 12px;"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Quick Actions Row -->
        <div style="margin-top: 16px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px;">
          <div style="display: flex; gap: 8px;">
            <button class="btn btn-sm btn-primary" (click)="applyFilters()" [disabled]="!hasActiveFilters()">
              <i class="fas fa-search me-1"></i>Apply Filters
            </button>
            <button class="btn btn-sm btn-outline-secondary" (click)="exportToExcel()">
              <i class="fas fa-download me-1"></i>Export
            </button>
          </div>
          <div *ngIf="!isLoading" style="font-size: 12px; color: var(--text-tertiary); display: flex; align-items: center; gap: 6px;">
            <i class="fas fa-list-alt" style="font-size: 11px;"></i>
            {{size}} records found
          </div>
        </div>

        <!-- Active Filter Tags -->
        <div *ngIf="hasActiveFilters()" style="margin-top: 12px; padding-top: 12px; border-top: 1px solid var(--border-subtle); display: flex; gap: 8px; flex-wrap: wrap; align-items: center;">
          <span style="font-size: 12px; color: var(--text-tertiary);">Active:</span>
          <span *ngIf="dateRange.from && dateRange.to" class="badge badge-light" style="display: inline-flex; align-items: center; gap: 4px;">
            <i class="fas fa-calendar" style="font-size: 10px;"></i>
            {{formatDate(dateRange.from)}} - {{formatDate(dateRange.to)}}
            <button style="background: none; border: none; padding: 0 0 0 4px; color: var(--text-tertiary); cursor: pointer; font-size: 10px;" (click)="clearDateFilter()">
              <i class="fas fa-times"></i>
            </button>
          </span>
          <span *ngIf="selectedPaymentMethod" class="badge badge-light" style="display: inline-flex; align-items: center; gap: 4px;">
            <i class="fas fa-exchange-alt" style="font-size: 10px;"></i>
            {{getPaymentMethodDisplay(selectedPaymentMethod)}}
            <button style="background: none; border: none; padding: 0 0 0 4px; color: var(--text-tertiary); cursor: pointer; font-size: 10px;" (click)="clearPaymentMethod()">
              <i class="fas fa-times"></i>
            </button>
          </span>
          <span *ngIf="searchTerm" class="badge badge-light" style="display: inline-flex; align-items: center; gap: 4px;">
            <i class="fas fa-search" style="font-size: 10px;"></i>
            "{{searchTerm}}"
            <button style="background: none; border: none; padding: 0 0 0 4px; color: var(--text-tertiary); cursor: pointer; font-size: 10px;" (click)="clearSearch()">
              <i class="fas fa-times"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Transactions Data Table -->
  <div class="data-panel">
    <div class="panel-header">
      <div class="panel-title">
        <div class="title-icon"><i class="fas fa-receipt"></i></div>
        <div>
          <div class="title-text">Wallet Transactions</div>
          <div class="title-subtitle">Monicredit wallet funding and settlement records</div>
        </div>
      </div>
      <div class="panel-info">
        <span class="info-item" style="font-size: 12px; color: var(--text-tertiary);">
          <span class="info-value" style="font-weight: 600; color: var(--text-secondary);">{{size}}</span> records
        </span>
      </div>
    </div>
    <div class="panel-body table-container" style="position: relative;">
      <!-- Loading Overlay -->
      <div *ngIf="isLoading" style="position: absolute; inset: 0; background: rgba(var(--bg-body), 0.6); z-index: 10; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(2px);">
        <div style="text-align: center;">
          <div class="loading-spinner" style="margin-bottom: 8px;">
            <div class="spinner-ring"></div>
          </div>
          <p style="font-size: 13px; color: var(--text-secondary); margin: 0;">Loading data...</p>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th>Transaction ID</th>
            <th>Amount</th>
            <th>Source Account</th>
            <th>Type</th>
            <th>Date</th>
            <th style="width: 60px;">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let transaction of monicreditTransactions; trackBy: trackByTransactionId">
            <td>
              <div>
                <div style="font-size: 13px; font-weight: 500; color: var(--accent);">{{ transaction.reference }}</div>
                <div style="font-size: 11px; color: var(--text-tertiary);">ID: {{transaction.id}}</div>
              </div>
            </td>
            <td>
              <span style="font-size: 14px; font-weight: 600; color: var(--text-primary);">₦{{transaction.amount_paid | number:'1.2-2'}}</span>
            </td>
            <td>
              <div>
                <div style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{transaction.source_account_name}}</div>
                <div style="font-size: 11px; color: var(--text-tertiary);">{{transaction.source_account_number}}</div>
              </div>
            </td>
            <td>
              <span class="badge badge-dot"
                    [ngClass]="{
                      'badge-soft-success': transaction.transaction_type === 'fund_wallet',
                      'badge-soft-info': transaction.transaction_type === 'transfer',
                      'badge-soft-warning': transaction.transaction_type === 'settlement',
                      'badge-soft-danger': transaction.transaction_type === 'withdrawal',
                      'badge-soft-secondary': !['fund_wallet','transfer','settlement','withdrawal'].includes(transaction.transaction_type)
                    }">
                {{transaction.transaction_type | titlecase}}
              </span>
            </td>
            <td>
              <div>
                <div style="font-size: 13px; color: var(--text-primary);">{{transaction.created_at | date:'MMM dd, yyyy'}}</div>
                <div style="font-size: 11px; color: var(--text-tertiary);">{{transaction.created_at | date:'HH:mm'}}</div>
              </div>
            </td>
            <td>
              <button class="btn btn-sm btn-outline-secondary" title="View Details" style="padding: 4px 8px;">
                <i class="fas fa-eye"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Empty State -->
      <div class="empty-state" *ngIf="monicreditTransactions.length === 0 && !isLoading">
        <div class="empty-icon"><i class="fas fa-receipt" style="font-size: 36px;"></i></div>
        <h5 class="empty-title">No transactions found</h5>
        <p class="empty-subtitle">No wallet transactions available at the moment</p>
        <button class="btn btn-primary btn-sm" (click)="getMonicreditTransactions(1)">
          <i class="fas fa-sync-alt me-1"></i>Refresh
        </button>
      </div>
    </div>

    <!-- Pagination Footer -->
    <div class="panel-footer" *ngIf="size > pageSize && !isLoading">
      <div class="pagination-info">
        Showing {{((page - 1) * pageSize) + 1}} to {{Math.min(page * pageSize, size)}} of {{size}} entries
      </div>
      <ngb-pagination
        [collectionSize]="size"
        [(page)]="page"
        [pageSize]="pageSize"
        [maxSize]="5"
        [rotate]="true"
        [ellipses]="false"
        [boundaryLinks]="true"
        (pageChange)="refresh($event)">
      </ngb-pagination>
    </div>
  </div>
</div>

<!-- Custom Date Template for Datepicker -->
<ng-template #dayTemplate let-date="date" let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
  <span
    class="calendar-day"
    [class.focused]="focused"
    [class.range]="isRange(date)"
    [class.faded]="isHovered(date) || isInside(date)"
    [class.disabled]="disabled"
    [class.hidden]="date.month !== currentMonth"
    (mouseenter)="hoveredDate = date"
    (mouseleave)="hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>
